<template>
  <div class="dashboard-widget">
    <h6 class="text-primary">Annual Enquiry Conversions</h6>
    <div class="md-layout stats-line">
      <div class="md-layout-item md-size-80 actions">
        <h6>No of Enquiries: {{ conversionData.count }}</h6>
      </div>
    </div>

    <chart-card
      v-if="loaded"
      header-animation="false"
      :chart-data="conversionData.data"
      :chart-options="chartOptions"
      chart-type="Pie"
      header-icon
      chart-inside-content
      ignore-empty-values
    >
      <template slot="footer">
        <div class="md-layout chart-footer">
          <div class="md-layout-item md-size-100">
            <h6 class="category">Legend</h6>
          </div>
          <div class="md-layout-item">
            <span class="legend-item"
              ><i class="fa fa-circle legend-1"></i> Ongoing</span
            >
            <span class="legend-item"
              ><i class="fa fa-circle legend-2"></i> Deferred</span
            >
            <span class="legend-item"
              ><i class="fa fa-circle legend-3"></i> Positive</span
            >
            <span class="legend-item"
              ><i class="fa fa-circle legend-4"></i> Negative</span
            >
          </div>
        </div>
      </template>
    </chart-card>
  </div>
</template>

<script>
import enquiryApi from "@/services/api/enquiry";
import { ChartCard } from "@/components";

export default {
  name: "WidgetEnquiryConversions",
  components: {
    ChartCard
  },

  data() {
    return {
      loaded: false,
      count: 10,
      conversionData: {
        count: 0,
        data: {
          series: [0, 0, 0, 0]
        }
      },
      chartOptions: {
        height: "240px"
      }
    };
  },

  computed: {},

  methods: {},

  created() {
    enquiryApi.getEnquiryConversions().then(response => {
      this.conversionData = response.data;
      this.loaded = true;
    });
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/md/_variables.scss";

h6 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
::v-deep .ct-series-a .ct-slice-pie,
::v-deep .legend-1 {
  fill: #00bcd4;
  color: #00bcd4;
  stroke: white;
}
::v-deep .ct-series-b .ct-slice-pie,
::v-deep .legend-2 {
  fill: #ff9800;
  color: #ff9800;
  stroke: white;
}
::v-deep .ct-series-c .ct-slice-pie,
::v-deep .legend-3 {
  fill: #66bb6a;
  color: #66bb6a;
  stroke: white;
}
::v-deep .ct-series-d .ct-slice-pie,
::v-deep .legend-4 {
  fill: #f44336;
  color: #f44336;
  stroke: white;
}

::v-deep .ct-label {
  color: white;
  fill: white;
  font-weight: bold;
}

::v-deep .md-card.md-card-chart .md-card-content {
  padding: 0;
}
::v-deep .md-card.md-card-chart .md-card-actions {
  margin: 0 5px 10px;
  padding: 0;
}

::v-deep .chart-footer .legend-item {
  margin-right: 20px;
}

.md-card.md-card-chart {
  margin-top: 10px;
  background-color: transparent;
}

.tour h6 {
  margin: 0;
}
p {
  margin: 0;
}
.departure-item {
  padding: 3px 0px;
  border-bottom: 1px solid #d2d2d2;
  cursor: pointer;
}
.actions {
  .action-button {
    width: 24px;
    min-width: 24px;
    height: 24px;
    margin: 0px;
  }
}
</style>
